module.exports = __webpack_public_path__ + "img/arout-electrical.82141cbf.jpg";